var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoPreview(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 153,
    viewBox: "0 0 169 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.016 98.8435C158.39 86.9342 163.876 76.373 163.876 76.373C163.876 76.373 135.039 20.8607 84.5729 20.8607C81.8669 20.8607 79.2231 21.0203 76.6426 21.3224C73.9287 21.6401 71.2848 22.1154 68.7122 22.7284M84.5729 52.582C87.3536 52.582 90.0228 53.0591 92.5033 53.9358C99.2632 56.3251 104.621 61.6828 107.01 68.4427C107.887 70.9231 108.364 73.5924 108.364 76.373M13.1999 5L155.946 147.746M84.5729 100.164C81.7922 100.164 79.123 99.687 76.6425 98.8103C69.8826 96.421 64.5249 91.0633 62.1356 84.3034C61.6848 83.0281 61.3397 81.7028 61.1108 80.3382M22.2961 52.582C19.8516 55.3141 17.6594 57.9938 15.7268 60.5124C8.86089 69.4597 5.26953 76.373 5.26953 76.373C5.26953 76.373 34.1071 131.885 84.5729 131.885C87.2789 131.885 89.9227 131.726 92.5033 131.424",
    stroke: "#8BA6C2",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPreview);
export default __webpack_public_path__ + "static/media/noPreview.e281d04aad14f8161fd271baba709557.svg";
export { ForwardRef as ReactComponent };